<template>
  <div class="home-container1">
    <header class="home-header">
      <header data-thq="thq-navbar" class="home-navbar-interactive">
        <div class="home-branding1">
          <a
            href="https://farmacie.md/ro/"
            target="_blank"
            rel="noreferrer noopener"
            class="home-link10"
          >
            farmacie.md
          </a>
          <svg viewBox="0 0 1024 1024" class="home-icon10">
            <path d="M128 128h768v768h-768z"></path>
          </svg>
        </div>
        <div data-thq="thq-navbar-nav" data-role="Nav" class="home-desktop-menu">
          <nav class="home-links1">
            <button class="home-button1 button">
              <a
                href="https://farmacie.md/ro/promo/seturi-cadou"
                target="_blank"
                rel="noreferrer noopener"
                class="home-link11"
              >
                Seturi Cadou
              </a>
            </button>
            <button class="home-button2 button">
              <a
                href="https://farmacie.md/ro/promo/oferte-speciale"
                target="_blank"
                rel="noreferrer noopener"
                class="home-link12"
              >
                Oferte Speciale
              </a>
            </button>
            <button class="home-button3 button">
              <a
                href="https://farmacie.md/ro/cabinet"
                target="_blank"
                rel="noreferrer noopener"
                class="home-link13"
              >
                Contul meu
              </a>
            </button>
          </nav>
        </div>
        <div data-thq="thq-burger-menu" class="home-burger-menu">
          <img
            alt="image"
            src="/group%202084%5B1%5D.svg"
            class="home-hamburger"
          />
        </div>
        <div data-thq="thq-mobile-menu" class="home-mobile-menu">
          <div class="home-top">
            <div class="home-branding2">
              <span class="home-text10">farmacie.md</span>
              <svg viewBox="0 0 1024 1024" class="home-icon12">
                <path d="M128 128h768v768h-768z"></path>
              </svg>
              <span class="home-text11">Remarkable</span>
            </div>
            <div data-thq="thq-close-menu" class="home-menu-close">
              <svg viewBox="0 0 1024 1024" class="home-icon14">
                <path
                  d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
                ></path>
              </svg>
            </div>
          </div>
          <nav class="home-links2">
            <button class="home-button4 button">
              <a
                href="https://farmacie.md/ro/promo/seturi-cadou"
                target="_blank"
                rel="noreferrer noopener"
                class="home-link14"
              >
                Seturi Cadou
              </a>
            </button>
            <button class="home-button5 button">
              <a
                href="https://farmacie.md/ro/promo/oferte-speciale"
                target="_blank"
                rel="noreferrer noopener"
                class="home-link15"
              >
                Oferte Speciale
              </a>
            </button>
            <button class="home-button6 button">
              <a
                href="https://farmacie.md/ro/cabinet"
                target="_blank"
                rel="noreferrer noopener"
                class="home-link16"
              >
                Contul meu
              </a>
            </button>
          </nav>
          <div class="home-social-bar">
            <a
              href="https://www.instagram.com/farmacie.md/"
              target="_blank"
              rel="noreferrer noopener"
              class="home-link17"
            >
              <svg viewBox="0 0 877.7142857142857 1024" class="home-icon16">
                <path
                  d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.facebook.com/farmacie.md/"
              target="_blank"
              rel="noreferrer noopener"
              class="home-link18"
            >
              <svg viewBox="0 0 602.2582857142856 1024" class="home-icon18">
                <path
                  d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"
                ></path>
              </svg>
            </a>
            <a
              href="https://www.youtube.com/c/FarmacieMd"
              target="_blank"
              rel="noreferrer noopener"
              class="home-link19"
            >
              <svg viewBox="0 0 1024 1024" class="home-icon20">
                <path
                  d="M1013.8 307.2c0 0-10-70.6-40.8-101.6-39-40.8-82.6-41-102.6-43.4-143.2-10.4-358.2-10.4-358.2-10.4h-0.4c0 0-215 0-358.2 10.4-20 2.4-63.6 2.6-102.6 43.4-30.8 31-40.6 101.6-40.6 101.6s-10.2 82.8-10.2 165.8v77.6c0 82.8 10.2 165.8 10.2 165.8s10 70.6 40.6 101.6c39 40.8 90.2 39.4 113 43.8 82 7.8 348.2 10.2 348.2 10.2s215.2-0.4 358.4-10.6c20-2.4 63.6-2.6 102.6-43.4 30.8-31 40.8-101.6 40.8-101.6s10.2-82.8 10.2-165.8v-77.6c-0.2-82.8-10.4-165.8-10.4-165.8zM406.2 644.8v-287.8l276.6 144.4-276.6 143.4z"
                ></path>
              </svg>
            </a>
          </div>
        </div>
      </header>
    </header>
    <header class="home-hero">
      <div class="home-content">
        <h1 class="home-title">
          <span>
            Aici găsești toate
            <span v-html="rawqlr2"></span>
          </span>
          <br />
          <span>OFERTELE</span>
        </h1>
        <span class="home-description">
          <span class="home-text15">
            Livrare rapidă în Chişinău și prin toată Moldova
          </span>
          <br class="home-text16" />
          <br class="home-text17" />
        </span>
        <img alt="image" src="/line-300w.webp" class="home-image1" />
      </div>
      <div class="home-image2">
        <img
          alt="image"
          srcset="/fmd//16605765596892025317-1400w.webp 1200w, /fmd/16605765596892025317-tablet.webp 800w, /fmd/16605765596892025317-mobile.webp 480w"
          sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
          src="/fmd/16605765596892025317-1400w.webp"
          class="home-image3"
        />
      </div>
    </header>
    <section class="home-mission">
      <h2 class="home-text18">
        <span>
          Descoperă mii de produse pentru sănătatea și confortul familiei tale.
          <span v-html="rawcq42"></span>
        </span>
        <span class="home-text20">Reduceri la MAXIM</span>
      </h2>
      <button class="home-button7 button">
        <a
          href="https://farmacie.md/ro/how-to-order"
          target="_blank"
          rel="noreferrer noopener"
          class="home-link20"
        >
          CUM COMAND
        </a>
      </button>
    </section>
    <div>
      <div class="home-container3">
        <style>
          .partner-container:hover .partner-image{
              filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(75deg) brightness(101%) contrast(102%);
          }
        </style>
      </div>
    </div>
  </div>
</template>

<script>
import DangerousHTML from 'dangerous-html/vue'

export default {
  name: 'Home',
  props: {},
  components: {
    DangerousHTML,
  },
  data() {
    return {
      rawqlr2: ' ',
      rawcq42: ' ',
    }
  },
  metaInfo: {
    title: 'farmacie online ✅ program de loialitate 🔥 Reduceri zilnice',
    meta: [
      {
        name: 'description',
        content:
          'farmacie online ✅ program de loialitate 🔥 Reduceri zilnice\nFă-ți cumpărăturile COMOD și INTELIGENT.',
      },
      {
        property: 'og:title',
        content: 'farmacie online ✅ program de loialitate 🔥 Reduceri zilnice',
      },
      {
        property: 'og:description',
        content:
          'farmacie online ✅ program de loialitate 🔥 Reduceri zilnice\nFă-ți cumpărăturile COMOD și INTELIGENT.',
      },
      {
        property: 'og:image',
        content:
          'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/58404fdd-7e70-4de8-a8f4-8e2bd32897f9/52da4997-475e-4611-96a0-7201beaaba7f?org_if_sml=1&q=80&force_format=original',
      },
    ],
  },
}
</script>

<style scoped>
.home-container1 {
  width: 100%;
  display: flex;
  overflow: hidden;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
 
.home-header {
  width: 100%;
  display: flex;
  z-index: 100;
  align-items: center;
  flex-direction: column;
}
 
.home-navbar-interactive {
  width: 100%;
  display: flex;
  position: relative;
  max-width: 1324px;
  align-items: center;
  padding-top: var(--dl-space-space-threeunits);
  padding-left: var(--dl-space-space-oneandhalfunits);
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: space-between;
}
 
.home-branding1 {
  gap: var(--dl-space-space-unit);
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
 
.home-link10 {
  fill: #2583e0;
  color: #2583e0;
  font-size: 30px;
  font-weight: bold;
  text-decoration: none;
}
 
.home-icon10 {
  width: 7px;
  height: 7px;
}
 
.home-desktop-menu {
  display: flex;
}
 
.home-links1 {
  gap: var(--dl-space-space-threeunits);
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
 
.home-button1 {
  color: rgb(18, 40, 33);
  font-size: 18px;
  font-family: Lato;
  line-height: 27px;
  padding-top: var(--dl-space-space-halfunit);
  padding-left: 0px;
  border-radius: 0px;
  padding-right: 0px;
  padding-bottom: var(--dl-space-space-halfunit);
  background-color: transparent;
}
 
.home-link11 {
  text-decoration: none;
}
 
.home-button2 {
  color: rgb(18, 40, 33);
  font-size: 18px;
  font-family: Lato;
  line-height: 27px;
  padding-top: var(--dl-space-space-halfunit);
  padding-left: 0px;
  border-radius: 0px;
  padding-right: 0px;
  padding-bottom: var(--dl-space-space-halfunit);
  background-color: transparent;
}
 
.home-link12 {
  text-decoration: none;
}
 
.home-button3 {
  color: rgb(18, 40, 33);
  font-size: 18px;
  font-family: Lato;
  line-height: 27px;
  padding-top: var(--dl-space-space-halfunit);
  padding-left: 0px;
  border-radius: 0px;
  padding-right: 0px;
  padding-bottom: var(--dl-space-space-halfunit);
  background-color: transparent;
}
 
.home-link13 {
  text-decoration: none;
}
 
.home-burger-menu {
  display: none;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
 
.home-hamburger {
  width: 100px;
  object-fit: cover;
}
 
.home-mobile-menu {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  display: flex;
  z-index: 100;
  position: fixed;
  transform: translateX(100%);
  transition: 0.5s;
  padding-top: var(--dl-space-space-threeunits);
  padding-left: var(--dl-space-space-oneandhalfunits);
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-threeunits);
  justify-content: flex-start;
  background-color: #fff;
}
 
.home-top {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-threeunits);
  justify-content: space-between;
}
 
.home-branding2 {
  gap: var(--dl-space-space-unit);
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
 
.home-text10 {
  color: rgba(18, 40, 33, 1);
  font-size: 24px;
  line-height: 36px;
}
 
.home-icon12 {
  width: 7px;
  height: 7px;
}
 
.home-text11 {
  color: rgba(18, 40, 33, 1);
  font-size: 18px;
  font-family: Lato;
  line-height: 27px;
}
 
.home-menu-close {
  display: flex;
  align-items: center;
  justify-content: center;
}
 
.home-icon14 {
  width: 34px;
  height: 34px;
}
 
.home-links2 {
  gap: var(--dl-space-space-unit);
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.home-button4 {
  color: var(--dl-color-gray-white);
  font-size: 18px;
  font-family: Lato;
  line-height: 27px;
  border-radius: 28px;
  background-color: rgb(18, 40, 33);
}
 
.home-link14 {
  text-decoration: none;
}
 
.home-button5 {
  color: var(--dl-color-gray-white);
  font-size: 18px;
  font-family: Lato;
  line-height: 27px;
  border-radius: 28px;
  background-color: rgb(18, 40, 33);
}
 
.home-link15 {
  text-decoration: none;
}
 
.home-button6 {
  color: var(--dl-color-gray-white);
  font-size: 18px;
  font-family: Lato;
  line-height: 27px;
  border-radius: 28px;
  background-color: rgb(18, 40, 33);
}
 
.home-link16 {
  text-decoration: none;
}
 
.home-social-bar {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  margin-top: auto;
  justify-content: flex-start;
}
 
.home-link17 {
  display: contents;
}
 
.home-icon16 {
  width: var(--dl-size-size-xsmall);
  height: var(--dl-size-size-xsmall);
  margin-right: var(--dl-space-space-twounits);
  text-decoration: none;
}
 
.home-link18 {
  display: contents;
}
 
.home-icon18 {
  width: var(--dl-size-size-xsmall);
  height: var(--dl-size-size-xsmall);
  margin-right: var(--dl-space-space-twounits);
  text-decoration: none;
}
 
.home-link19 {
  display: contents;
}
 
.home-icon20 {
  width: var(--dl-size-size-xsmall);
  height: var(--dl-size-size-xsmall);
  text-decoration: none;
}
 
.home-hero {
  gap: var(--dl-space-space-threeunits);
  width: 100%;
  height: 600px;
  display: flex;
  position: relative;
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  padding-left: var(--dl-space-space-oneandhalfunits);
  padding-right: var(--dl-space-space-oneandhalfunits);
  flex-direction: row;
}
 
.home-content {
  gap: var(--dl-space-space-unit);
  width: auto;
  display: flex;
  position: relative;
  max-width: 1280px;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-end;
}
 
.home-title {
  color: rgb(18, 40, 33);
  width: 584px;
  font-size: 72px;
  max-width: 600px;
  font-style: normal;
  font-weight: 500;
  line-height: 92px;
}
 
.home-description {
  color: rgb(18, 40, 33);
  font-size: 24px;
  max-width: 600px;
  font-family: "Lora";
  line-height: 36px;
}
 
.home-text16 {
  color: #122821;
  font-size: 24px;
  line-height: 36px;
}
 
.home-image1 {
  left: 0px;
  width: 240px;
  bottom: -410px;
  height: 330px;
  position: absolute;
  object-fit: cover;
}
 
.home-image2 {
  width: 567px;
  height: 568px;
  display: flex;
  overflow-x: hidden;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: rgba(250, 228, 142, 1);
}
 
.home-image3 {
  width: 566px;
  height: 100%;
  object-fit: cover;
}
 
.home-mission {
  gap: var(--dl-space-space-threeunits);
  width: 100%;
  display: flex;
  max-width: 1280px;
  align-items: flex-start;
  padding-top: 120px;
  padding-left: 290px;
  flex-direction: column;
  padding-bottom: 120px;
}
 
.home-text18 {
  color: rgb(18, 40, 33);
  font-size: 40px;
  max-width: 1000px;
  font-style: normal;
  font-weight: 500;
  line-height: 51px;
}
 
.home-text20 {
  font-weight: 900;
}
 
.home-button7 {
  color: #f1f5f3;
  width: 480px;
  font-size: 30px;
  background-color: #2583e0;
}
 
.home-link20 {
  line-height: 21px;
  text-decoration: none;
}
 
.home-container3 {
  display: contents;
}
 
@media(max-width: 991px) {
  .home-navbar-interactive {
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
  }
  .home-icon10 {
    display: none;
  }
  .home-icon12 {
    display: none;
  }
  .home-text11 {
    display: none;
  }
  .home-hero {
    gap: var(--dl-space-space-threeunits);
    height: auto;
    align-items: flex-start;
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    flex-direction: column;
  }
  .home-image1 {
    display: none;
  }
  .home-image2 {
    width: 100%;
    height: auto;
    position: static;
    align-items: flex-end;
    aspect-ratio: 1;
    justify-content: flex-start;
  }
  .home-image3 {
    width: 100%;
  }
  .home-mission {
    gap: var(--dl-space-space-unit);
    padding-top: var(--dl-space-space-threeunits);
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-fourunits);
  }
  .home-text18 {
    font-size: 18px;
    text-align: center;
    line-height: 23px;
  }
  .home-button7 {
    width: 100%;
    text-align: center;
  }
  .home-link20 {
    font-family: Lato;
  }
}
 
@media(max-width: 767px) {
  .home-desktop-menu {
    display: none;
  }
  .home-burger-menu {
    width: 40px;
    height: 40px;
    display: flex;
    aspect-ratio: 1;
    border-radius: var(--dl-radius-radius-round);
    justify-content: center;
    background-color: #E6F9E0;
  }
  .home-hamburger {
    width: 16px;
    height: 8px;
  }
  .home-button4 {
    color: rgb(18, 40, 33);
    padding-left: 0px;
    background-color: transparent;
  }
  .home-button5 {
    color: rgb(18, 40, 33);
    padding-left: 0px;
    background-color: transparent;
  }
  .home-button6 {
    color: rgb(18, 40, 33);
    padding-left: 0px;
    background-color: transparent;
  }
  .home-social-bar {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .home-title {
    font-size: 36px;
    line-height: 46px;
  }
  .home-description {
    font-size: 16px;
    line-height: 24px;
  }
  .home-text15 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-text17 {
    font-size: 16px;
    line-height: 24px;
  }
  .home-mission {
    align-items: center;
  }
}
 
@media(max-width: 479px) {
  .home-text10 {
    color: #00020a;
    font-size: 24px;
    font-family: Onest;
    font-weight: bold;
    line-height: 36px;
  }
  .home-link14 {
    font-family: Onest;
  }
  .home-link15 {
    font-family: Onest;
    text-decoration: none;
  }
  .home-link16 {
    font-family: Onest;
    text-decoration: none;
  }
  .home-social-bar {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .home-title {
    color: rgb(18, 40, 33);
    width: 100%;
    font-size: 36px;
    font-style: normal;
    font-family: Onest;
    font-weight: 800;
    line-height: 46px;
  }
  .home-description {
    font-family: Onest;
  }
  .home-text18 {
    font-family: Onest;
  }
  .home-link20 {
    font-family: Onest;
  }
}
</style>
